/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateVendorDocumentDto } from '../../models/create-vendor-document-dto';
import { VendorDocumentDto } from '../../models/vendor-document-dto';

export interface VendorDocumentControllerCreate$Params {
      body: CreateVendorDocumentDto
}

export function vendorDocumentControllerCreate(http: HttpClient, rootUrl: string, params: VendorDocumentControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorDocumentDto>> {
  const rb = new RequestBuilder(rootUrl, vendorDocumentControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VendorDocumentDto>;
    })
  );
}

vendorDocumentControllerCreate.PATH = '/api/vendorDocument';
